/**
 * Notification Center — REST client.
 */
import { apiClient } from './client';

export const listNotifications = (params = {}, { pollTag } = {}) =>
  apiClient.get('/notifications', {
    params,
    ...(pollTag ? { headers: { 'X-Trigger': `poll:${pollTag}` } } : {}),
  });

export const getUnreadCount = () =>
  apiClient.get('/notifications/unread-count');

export const markNotificationRead = (id) =>
  apiClient.post(`/notifications/${id}/read`, {});

export const markAllNotificationsRead = () =>
  apiClient.post('/notifications/read-all', {});

export const getNotificationRouting = () =>
  apiClient.get('/notifications/routing');

export const saveNotificationRouting = (categories) =>
  apiClient.put('/notifications/routing', { categories });

export const getNotificationPrefs = () =>
  apiClient.get('/notifications/prefs');

export const saveNotificationPrefs = (categories) =>
  apiClient.put('/notifications/prefs', { categories });

export const listFollows = () =>
  apiClient.get('/notifications/follows');

export const followJob = (jobId) =>
  apiClient.put(`/notifications/follows/${jobId}`, {});

export const unfollowJob = (jobId) =>
  apiClient.delete(`/notifications/follows/${jobId}`);
